import Grid from '@mui/material/Grid';
import { InputAdornment, TextField } from '@mui/material';
import { textFieldStyles } from './style';

const CustomTextField = (props = {}) => {
  //Input field props, inherit from component performed the instance:
  const {
    fieldType,
    fieldLabel,
    fieldPlaceholder,
    fieldDisabled,
    fileldDefaultValue,
    fieldStartIcon,
    fielEndIcon,
    fieldClassName,
    fieldName,
    fieldMethods,
    fieldOnBlur,
    fieldOnChange,
    fieldRequired,
    fieldError,
  } = props;

  //Return input field component:
  return (
    <Grid item size={{ xs: 12 }}>
      <TextField
        // variant="standard"
        sx={textFieldStyles}
        type={fieldType || 'text'}
        label={fieldLabel || ''}
        placeholder={fieldPlaceholder || ''}
        disabled={fieldDisabled}
        defaultValue={fileldDefaultValue || ''}
        className={fieldClassName || ''}
        InputProps={{
          startAdornment: <InputAdornment position='start'>{fieldStartIcon || ''}</InputAdornment>,
          endAdornment: <InputAdornment position='end'>{fielEndIcon || ''}</InputAdornment>,
        }}
        {...fieldMethods.register(fieldName || '', {
          onBlur: (e) => (typeof fieldOnBlur === 'function' ? fieldOnBlur(e, fieldName) : {}),
          onChange: (e) => (typeof fieldOnChange === 'function' ? fieldOnChange(e, fieldName) : {}),
          ...fieldRequired,
        })}
      />
      {fieldError}
    </Grid>
  );
};

export default CustomTextField;
